var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-github",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 29.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.01 0C6.71 0 0 6.76 0 15.12c0 6.69 4.3 12.34 10.27 14.35.75.15 1.02-.33 1.02-.73 0-.35-.02-1.55-.02-2.8-4.18.9-5.05-1.8-5.05-1.8-.67-1.75-1.67-2.2-1.67-2.2-1.37-.93.1-.93.1-.93 1.52.1 2.31 1.55 2.31 1.55 1.34 2.3 3.5 1.65 4.37 1.25.12-.98.52-1.65.94-2.03-3.33-.35-6.84-1.65-6.84-7.46 0-1.65.6-3 1.54-4.06-.15-.38-.67-1.93.15-4.01 0 0 1.27-.4 4.13 1.55 1.22-.33 2.49-.5 3.75-.5 1.27 0 2.56.18 3.75.5 2.86-1.95 4.13-1.55 4.13-1.55.82 2.08.3 3.63.15 4.01.97 1.05 1.54 2.4 1.54 4.06 0 5.81-3.5 7.09-6.86 7.46.55.48 1.02 1.38 1.02 2.8 0 2.03-.02 3.66-.02 4.16 0 .4.27.88 1.02.73C25.7 27.47 30 21.81 30 15.12 30.02 6.76 23.29 0 15.01 0Z",
    "data-name": "Social Media Icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c091268d724168a5d3fbfebc53f13299.svg";
export { ForwardRef as ReactComponent };